module.exports = __webpack_public_path__ + "static/media/Island_Lake_Vineyards_Bylaws_Amendment.8e32fc62.pdf";